import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-08fa34ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-container" }
const _hoisted_2 = { class: "payment-overview-block-wrapper flex-wrapper flex-height" }
const _hoisted_3 = { class: "payment-overview-block" }
const _hoisted_4 = { class: "payment-search-wrapper" }
const _hoisted_5 = { class: "payment-search-row" }
const _hoisted_6 = { class: "search-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Round ", -1))
const _hoisted_8 = { class: "search-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Dealer Code ", -1))
const _hoisted_10 = { class: "search-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Dealer Name ", -1))
const _hoisted_12 = { class: "search-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Vendor Code ", -1))
const _hoisted_14 = { class: "payment-search-row" }
const _hoisted_15 = { class: "search-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Region ", -1))
const _hoisted_17 = { class: "search-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Dealer Group ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_21 = { class: "search-btn" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_24 = { class: "payment-overview-block mt-10 flex-wrapper flex-height" }
const _hoisted_25 = { class: "content-header" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "A3 Tracking")
], -1))
const _hoisted_27 = { class: "control-wrapper" }
const _hoisted_28 = {
  key: 0,
  class: "pagination-container d-f justify-e"
}
const _hoisted_29 = {
  ref: "ssHost",
  style: {"width":"1200px","height":"700px"},
  id: "ssHost"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_FileSearchOutlined = _resolveComponent("FileSearchOutlined")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_upload_file = _resolveComponent("upload-file")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_a_select, {
                  value: _ctx.query.payoutRound,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.payoutRound) = $event)),
                  class: "sel-inp-size",
                  placeholder: "Please select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roundList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.query.dealerCode,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.dealerCode) = $event))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.query.dealerName,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.dealerName) = $event))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.query.vendorCode,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.vendorCode) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.query.region,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.region) = $event))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.query.dealerGroup,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.query.dealerGroup) = $event))
                }, null, 8, ["value"])
              ]),
              _hoisted_19,
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"15px"},
                onClick: _ctx.reset
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pageChange(1)))
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_FileSearchOutlined, {
                class: "mr-10",
                onClick: _ctx.preview
              }, null, 8, ["onClick"]),
              _createVNode(_component_UploadOutlined, {
                class: "mr-10",
                onClick: _ctx.upload
              }, null, 8, ["onClick"]),
              _createVNode(_component_DownloadOutlined, { onClick: _ctx.download }, null, 8, ["onClick"])
            ])
          ]),
          _createVNode(_component_table_wrapper, { "is-pagination": _ctx.isPagination }, {
            default: _withCtx((slotProps) => [
              _createVNode(_component_a_table, {
                scroll: { y: slotProps.tableHeight, x: _ctx.tableWidth },
                dataSource: _ctx.data,
                columns: _ctx.columnTracking,
                rowKey: "no",
                pagination: false,
                rowSelection: _ctx.tableSelection
              }, null, 8, ["scroll", "dataSource", "columns", "rowSelection"])
            ]),
            _: 1
          }, 8, ["is-pagination"]),
          (_ctx.isPagination)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_a_pagination, {
                  total: _ctx.total,
                  "show-size-changer": "",
                  "show-total": (total) => `共 ${total} 条`,
                  onChange: _ctx.pageChange,
                  onShowSizeChange: _ctx.sizeChange,
                  pageSize: _ctx.pageSize,
                  "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
                  current: _ctx.pageNumber,
                  "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pageNumber) = $event)),
                  pageSizeOptions: ['10', '20', '30', '40', '50']
                }, {
                  buildOptionText: _withCtx((props) => [
                    _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
                  ]),
                  _: 1
                }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "current"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_upload_file, {
      visible: _ctx.uploadVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uploadVisible) = $event)),
      payoutRound: _ctx.query.payoutRound,
      onUploadSuccess: _ctx.uploadSuccess
    }, null, 8, ["visible", "payoutRound", "onUploadSuccess"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.previewFlg,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.previewFlg) = $event)),
      width: 1280,
      footer: null,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, null, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}